import Layout from "../components/ui/layout";
import useDocumentTitle from "../utils/useDocumentTitle";
import { ProjectList } from "../data/projects";
import {Project} from "../components/ui/Project";

const Projects = () => {

    useDocumentTitle('Mahri Ilmedova | Projects')

    return (
        <Layout>
            <section className="p-4 pb-12 max-w-6xl m-auto overflow-hidden 2xl:overflow-visible">
                <div className="flex flex-col gap-20">
                    {ProjectList.map((project) => (
                        <Project
                            key={`project-item-${project.title}`}
                            {...project}
                        />
                    ))}
                </div>
            </section>
        </Layout>
    )
}

export default Projects;
